<div class="container py-4" [ngClass]="containerClasses" data-cy="DIV-7520">
  <ng-content></ng-content>
</div>
